import { View, StyleSheet } from 'react-native'

interface cardSeparatorProps {
  light?: boolean
  narrowTop?: boolean
  narrowBottom?: boolean
  withGap?: boolean
}

const CardSeparator = ({
  light,
  narrowTop,
  narrowBottom,
  withGap
}: cardSeparatorProps): JSX.Element => {
  return (
    <View
      style={[
        styles.separator,
        withGap && styles.separatorWithGap,
        light && styles.separatorLight,
        narrowTop && styles.separatorNarrowTop,
        narrowBottom && styles.separatorNarrowBottom
      ]}
    />
  )
}

const styles = StyleSheet.create({
  separator: {
    borderBottomColor: '#CCCCCC',
    borderBottomWidth: 1,
    marginHorizontal: -20,
    marginVertical: 20
  },
  separatorWithGap: {
    marginHorizontal: 0
  },
  separatorLight: {
    borderBottomColor: '#EEEEEE'
  },
  separatorNarrowTop: {
    marginTop: 15
  },
  separatorNarrowBottom: {
    marginBottom: 15
  }
})

export default CardSeparator
